import React from 'react';
import { Tooltip, Icon } from 'antd';
import classNames from 'classnames';

import { toggleMessageType, voteForSummary } from '../api';
import { useGlobalState } from '../state';
import { USER_NAME_STORAGE_KEY } from './UserNameModal';


function checkIfCurrentUserVoted(voters) {
  const userName = localStorage.getItem(USER_NAME_STORAGE_KEY);
  return voters && voters.some(voter => voter === userName);
}

const MAX_DISPLAYED_VOTER_COUNT = 3;
function VotersList({ voters }) {
  const partialVoters = voters.slice(0, MAX_DISPLAYED_VOTER_COUNT);
  const remainingVoterCount = voters.length - partialVoters.length
  return (
    <span>
      {partialVoters.map((voter, i) => (
        <span key={voter}>{voter}{i !== partialVoters.length - 1 && ', '}</span>
      ))}
      {remainingVoterCount > 0 && <span>{' '} and {remainingVoterCount} more</span>}
    </span>
  )
}

export function SummaryVoteYes({ message, disabled }) {
  const { id } = message;
  const [summaryVotesById,] = useGlobalState('summaryVotesById');

  const { yesVotes, yesVoters } = summaryVotesById[id] || {};
  const hasCurrentUserVoted = checkIfCurrentUserVoted(yesVoters);
  const disabledClassName = classNames({ disabled });

  return (
    <Tooltip className={disabledClassName} title={yesVoters && yesVoters.length > 0 && <VotersList voters={yesVoters} />}>
      <span>
        <Icon
          className={disabledClassName}
          style={{ paddingRight: '0.1rem' }}
          onClick={async () => { !disabled && await voteForSummary(id, 'yes'); }}
          type="like"
          theme={hasCurrentUserVoted ? 'filled' : 'outlined'}
        />
        {yesVotes || 0}
      </span>
    </Tooltip>
  )
}

export function SummaryVoteNo({ message, disabled }) {
  const { id } = message;

  const [summaryVotesById,] = useGlobalState('summaryVotesById');

  const { noVoters, noVotes } = summaryVotesById[id] || {};
  const hasCurrentUserVoted = checkIfCurrentUserVoted(noVoters);
  const disabledClassName = classNames({ disabled })

  return (
    <Tooltip className={disabledClassName} title={noVoters && noVoters.length > 0 && <VotersList voters={noVoters} />}>
      <span>
        <Icon
          className={disabledClassName}
          style={{ paddingRight: '0.1rem' }}
          onClick={async () => { !disabled && await voteForSummary(id, 'no'); }}
          type="dislike"
          theme={hasCurrentUserVoted ? 'filled' : 'outlined'}
        />
        {noVotes || 0}
      </span>
    </Tooltip>
  )
}


export function SummaryAction({ message }) {
  const { summary_status, id } = message;
  const isApprovedSummary = summary_status === 'approved';

  return (
    <Tooltip title="Summary">
      <Icon
        onClick={async () => { await toggleMessageType(id); }}
        type="star"
        theme={isApprovedSummary ? 'filled' : 'outlined'}
      />
    </Tooltip>
  );
}
